// extracted by mini-css-extract-plugin
export default {"reasonsContainer":"ReasonChoices_reasonsContainer__GkkKC","header":"ReasonChoices_header__vKGec","noReasons":"ReasonChoices_noReasons__4l1L5"};